<div class="grid m-0 " >
  <div class="col-12">
    <div class="button-box">
      <h1 [style.margin-top]="'32px'" [style.margin-bottom]="'48.002px'" >Dados</h1>
    </div>
    <div class="col-12 border-round-2xl bg-white mt-5 p-5">
      <split-inside-menu
        [data]="menu"
        (currentIndex)="changeIndex($event)"
        [itemWidth]="'15rem'"
      ></split-inside-menu>
    </div>
    <div class="col-12 border-round-2xl bg-white m-0 p-6 mt-4">
      <div class="grid m-0 p-0">
        <div class="col-12 m-0 p-0">
          <ng-container *ngIf="abaSelecionada == 0">
            <app-dados-receitas></app-dados-receitas>
          </ng-container>

          <ng-container *ngIf="abaSelecionada == 1">
            <app-dados-profissoes></app-dados-profissoes>
          </ng-container>

          <ng-container *ngIf="abaSelecionada == 2">
            <app-dados-despesas></app-dados-despesas>
          </ng-container>

          <!-- <ng-container *ngIf="abaSelecionada == 3">
            <app-dados-pastas></app-dados-pastas>
          </ng-container> -->
          <!-- <ng-container *ngIf="abaSelecionada == 3">
            <app-dados-servicos></app-dados-servicos>
          </ng-container> -->
          <ng-container *ngIf="abaSelecionada == 3">
            <app-dados-repasse></app-dados-repasse>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
